import React from "react";
import RCCAPRReport from "components/RCCAPRReport";

export default function RCCProgressReport() {
  return <RCCAPRReport embedded />;
}